var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRub = function SvgRub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm-5.2-2.7c0-1.8-1.5-3.3-3.3-3.3H7.6c-.36 0-.6.24-.6.6v4.2H5.8c-.36 0-.6.24-.6.6v.6c0 .36.24.6.6.6H7v1.2H5.8c-.36 0-.6.24-.6.6v.6c0 .36.24.6.6.6H7v1.8c0 .36.24.6.6.6h1.2c.36 0 .6-.24.6-.6v-1.8h2.4c.36 0 .6-.24.6-.6v-.6c0-.36-.24-.6-.6-.6H9.4v-1.2h2.1c1.8 0 3.3-1.5 3.3-3.3zm-3.9-1.5H9.4v3h1.5c.84 0 1.5-.66 1.5-1.5s-.66-1.5-1.5-1.5z"
  })));
};
export default SvgRub;